import { cloneElement, ReactElement } from "react"
import SegmentedButtonGroup from "./SegmentedButtonGroup"

type ButtonProps = {
    value: string
    tooltip: string
    icon: ReactElement
}

interface Props {
    buttons: ButtonProps[]
    property: string
    value: string
    handleOnChange: (property: any, value: any) => void
}

/**
 * Exclusive options as joined icon buttons (text align, direction…), in the same look as
 * every other icon button of the panel (see SegmentedButtonGroup). Fills its column; the
 * current option is the one shown on.
 */
const ButtonGroupInput = ({ buttons, property, value, handleOnChange }: Props) => (
    <SegmentedButtonGroup
        segments={buttons.map((b) => ({
            title: b.tooltip,
            icon: cloneElement(b.icon, { fontSize: "small" }),
            // the current option again changes nothing — the old toggle group cleared the
            // style to null on a second click
            onClick: () => b.value !== value && handleOnChange(property, b.value),
            selected: b.value === value,
        }))}
    />
)

export default ButtonGroupInput
